<template>
  <svg width="42" height="42" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <filter x="-30%" y="-23.3%" width="160%" height="160%" filterUnits="objectBoundingBox" id="a">
        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
        <feOffset dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0 0.356862745 0 0 0 0.25 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <circle id="b" cx="15" cy="15" r="15" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(6 4)">
        <use fill="#000" filter="url(#a)" xlink:href="#b" />
        <circle stroke="#FFF" stroke-width="2" fill="#9F8054" cx="15" cy="15" r="16" />
      </g>
      <path
        d="M28.548 11.952a1.543 1.543 0 0 0-2.205.023l-3.278 3.415-7.706-2.55a.5.5 0 0 0-.51.121l-1.014 1.014a.5.5 0 0 0 .091.78l6.129 3.772-3.374 3.516-1.91-.314a.5.5 0 0 0-.435.14l-.774.774a.5.5 0 0 0 .189.825l2.43.851.85 2.43a.5.5 0 0 0 .826.189l.774-.774a.5.5 0 0 0 .14-.435l-.314-1.91 3.516-3.374 3.773 6.129a.5.5 0 0 0 .78.091l1.013-1.014a.5.5 0 0 0 .121-.51l-2.55-7.706 3.415-3.278a1.543 1.543 0 0 0 .023-2.205Z"
        fill="#FFF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPoiAirport',
};
</script>

<style></style>
